export const articleListItemStyle = theme => ({
  root: {
    minHeight: 'calc(100% - 20px)',
    margin: 0,
    '&-marginTop': {
      marginTop: theme.spacing(2),
    },
  },
  mainBg: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative',
    overflow: 'hidden',
    minHeight: '215px',
    color: 'white',
    paddingTop: '25px',
    paddingBottom: '25px',
    '&::before': {
      content: "''",
      display: 'block',
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      background:
        'linear-gradient(73.18deg, #687C86 1.66%, rgba(104, 124, 134, 0) 98.47%)',
    },
  },
  imageBg: {
    minHeight: '215px',
    padding: '0',
    objectFit: 'contain',
  },

  headerBox: {
    position: 'relative',
    height: '100px',
  },

  fullWidth: {
    width: '100%',
  },
  title: {
    fontSize: '16px',
    fontWeight: 400,
  },
  description: {
    margin: 0,
  },
  // cardFooter: {
  //   background: 'red',
  // },
})
